<template>
  <div class="language-switcher">
    <v-menu
      v-model="menu"
      :close-on-content-click="true"
      offset-y
      :bottom="!expand"
      :top="expand"
      max-width="220"
      nudge-bottom="2"
      transition="slide-y-transition"
      attach
      content-class="language-menu-content"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          fab
          small
          v-bind="attrs"
          v-on="on"
          class="language-btn"
          :loading="loading"
        >
          <v-icon :color="textColor ||'white'">mdi-translate</v-icon>
        </v-btn>
      </template>

      <v-list
        dense
        class="py-0"
        :style="{ background: headColor, color: textColor }"
      >
        <v-list-item-group v-model="selectedLang" mandatory class="py-0 my-0">
          <template v-for="item in filteredLanguages">
            <v-list-item
              :key="item.lang"
              @click="selectLanguage(item)"
              :disabled="loading"
              class="language-item py-0 my-0"
            >
              <v-list-item-avatar size="20" class="mr-3">
                <img :src="item.flag" :alt="item.name" class="rounded-flag" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  {{ $t(`language.lang.${item.lang}`) }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-icon
                  v-if="item.lang === currentlanguage"
                  class="pulse-check"
                >
                  mdi-check-circle
                </v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-divider
              v-if="
                item.lang !==
                filteredLanguages[filteredLanguages.length - 1].lang
              "
              :key="'div-' + item.lang"
              class="my-1"
              :style="{ borderColor: textColor + '44' }"
            />
          </template>
        </v-list-item-group>

        <!-- وقتی هیچ زبانی موجود نیست -->
        <v-list-item v-if="!filteredLanguages.length">
          <v-list-item-content class="text-center">
            <span :style="{ opacity: 0.7 }">{{
              $t("language.no_languages_available")
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "languageswitcherpopup",
  props: {
    currentLang: {
      type: String,
      default: "fa",
    },
    expand: { type: Boolean, default: true },
    textColor: { type: String, default: "#ffffff" },
    headColor: { type: String, default: "#2c3e50" },
  },
  data() {
    return {
      menu: false,
      loading: false,
      selectedLang: null,
      allLanguages: [
        {
          lang: "en_US",
          name: "English (US)",
          flag: "/media/flag/us.svg",
        },
        {
          lang: "en_GB",
          name: "English (UK)",
          flag: "/media/flag/gb.svg",
        },
        {
          lang: "fa",
          name: "فارسی",
          flag: "/media/flag/ir.svg",
        },
        {
          lang: "ar",
          name: "العربية",
          flag: "/media/flag/sa.svg",
        },
        {
          lang: "ar_ae",
          name: "العربية (الإمارات)",
          flag: "/media/flag/ae.svg",
        },
        {
          lang: "ar_iq",
          name: "العربية (العراق)",
          flag: "/media/flag/iq.svg",
        },
        {
          lang: "de",
          name: "Deutsch",
          flag: "/media/flag/de.svg",
        },
        {
          lang: "fr",
          name: "Français",
          flag: "/media/flag/fr.svg",
        },
        {
          lang: "hy",
          name: "Հայերեն",
          flag: "/media/flag/am.svg",
        },
        {
          lang: "ru",
          name: "Русский",
          flag: "/media/flag/ru.svg",
        },
        {
          lang: "tr",
          name: "Türkçe",
          flag: "/media/flag/tr.svg",
        },
        {
          lang: "zh_CN",
          name: "简体中文",
          flag: "/media/flag/cn.svg",
        },
        {
          lang: "zh_TW",
          name: "繁體中文",
          flag: "/media/flag/tw.svg",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("localstorage", [
      "alllangs",
      "defaultLang",
      "currentlanguage",
    ]),

    filteredLanguages() {
      if (!this.alllangs || this.alllangs.length === 0) return [];
      const available = new Set(this.alllangs);
      if (this.defaultLang) available.add(this.defaultLang);
      return this.allLanguages.filter((l) => available.has(l.lang));
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCurrentLanguage"]),
    selectLanguage(item) {
      if (item.lang === this.currentLang) {
        this.menu = false;
        return;
      }

      this.loading = true;
      this.$emit("source-changed", item.lang);

      setTimeout(() => {
        this.setCurrentLanguage(item.lang);
        this.menu = false;
        this.loading = false;
      }, 300);
    },
  },
};
</script>
<style scoped>
.language-btn {
}
.language-list {
  padding: 4px 0 !important;
}

.language-item {
  min-height: 36px !important;
  height: 36px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin: 0 !important;
}

.language-item :deep(.v-list-item__avatar) {
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  min-width: 24px !important;
}

.language-item :deep(.v-list-item__content) {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.language-item :deep(.v-list-item__action) {
  margin: 0 8px 0 16px !important;
  min-width: auto !important;
}

.rounded-flag {
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid rgba(0, 0, 0, 0.12);
  width: 24px;
  height: 24px;
}

.language-item:hover {
  background-color: rgba(0, 0, 0, 0.06) !important;
}

::v-deep .language-menu-content {
  z-index: 999999999999 !important;
  contain: none !important;
}
.language-switcher {
  z-index: 9999999999 !important;
}
.language-menu-content {
  overflow-y: scroll;
  height: 300px;
  background-color: white !important;
}
.v-divider {
  margin: 2px !important;
  border: 1px solid rgba(187, 186, 186, 0.164);
}
language-switcher {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* مهم‌ترین قسمت: منوی پاپ‌آپ Vuetify 2 رو کاملاً inherit می‌کنیم */
::v-deep .my-language-menu {
  background: inherit !important;
  color: inherit !important;
  contain: none !important;
}

::v-deep .my-language-menu .v-list {
  background: inherit !important;
  color: inherit !important;
  padding: 8px 0 !important;
}

::v-deep .my-language-menu .v-list-item {
  min-height: 42px !important;
  color: inherit !important;
}

::v-deep .my-language-menu .v-list-item::before {
  background-color: transparent !important; /* حذف رنگ hover پیش‌فرض */
}

::v-deep .my-language-menu .v-list-item--active,
::v-deep .my-language-menu .v-list-item:hover {
  background: rgba(255, 255, 255, 0.15) !important; /* برای تم تیره */
  /* اگر تم روشن داری اینو بذار: */
  /* background: rgba(0, 0, 0, 0.08) !important; */
}

::v-deep .my-language-menu .v-list-item__title,
::v-deep .my-language-menu .v-list-item__subtitle,
::v-deep .my-language-menu .v-list-item__action {
  color: inherit !important;
  opacity: 1 !important;
}

.rounded-flag {
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
::v-deep .my-language-menu .v-menu__content {
  overflow-y: auto;
  max-height: 340px;
}
::v-deep .my-language-menu::-webkit-scrollbar {
  width: 6px;
}
::v-deep .my-language-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}
::v-deep .font-weight-medium,
.language-item,
::v-deep .text-caption {
  color: inherit !important;
  background-color: inherit !important;
}
.pulse-check {
  animation: pulse 2s infinite ease-in-out;
  color: inherit !important;
  background-color: inherit !important;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
}
</style>
